// Offered once, when a screen share starts on a computer: open the small
// window that keeps the other people (and Breeze) in view over the share. It
// is a card with buttons rather than a window opened for them, because the
// browser only allows a pop-out from a click.

import type { JSX } from "react";
import { surfaceNotice, type ShareSurface } from "@breeze/core";

interface PopoutOfferProps {
  readonly surface: ShareSurface | null;
  readonly onOpen: () => void;
  readonly onDismiss: () => void;
}

export function PopoutOffer({ surface, onOpen, onDismiss }: PopoutOfferProps): JSX.Element {
  const notice = surfaceNotice(surface);
  return (
    <div className="popoffer" role="group" aria-label="Pop out" data-testid="popout-offer">
      <p className="popoffer__title">Keep the call in view while you share.</p>
      <p className="popoffer__note">
        A small window with the others{notice ? "" : " and Breeze"} stays on top of whatever you share.
      </p>
      {notice ? <p className="popoffer__note">{notice}</p> : null}
      <div className="popoffer__actions">
        <button type="button" className="btn btn--ghost btn--sm" onClick={onDismiss}>
          Not now
        </button>
        <button type="button" className="btn btn--primary btn--sm" onClick={onOpen}>
          Pop out
        </button>
      </div>
    </div>
  );
}
